import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';

// Initialize Supabase using environment variables
const supabaseUrl = "https://jhfvlccefrzuojvaoilz.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpoZnZsY2NlZnJ6dW9qdmFvaWx6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2MDY3NzcsImV4cCI6MjA1NjE4Mjc3N30.3PnGkLaonvbP7VvGbxIxxPxo0ztoAg9uPk23trH2PYs";
const supabase = createClient(supabaseUrl, supabaseAnonKey);

function Confirm() {

    const [isLoader, setIsLoader] = useState(false)

    // You can now use the supabase client to interact with your Supabase database
    const handleClick = async () => {

        document.getElementById("loader").classList.add("tatsu-form-lightbox-visible")

        const bottomName = document.getElementById('bottom-name').value;
        const bottomEmail = document.getElementById('bottom-email').value;
        const bottomPhone = document.getElementById('bottom-phone').value;
        const bottomInsuranceType = document.getElementById('bottom-insurance_type').value;
        const bottomTreatmentReason = document.getElementById('bottom-treatment_reason').value;
        const bottomCityValue = document.getElementById('bottom-city').value;
        const bottomMessage = document.getElementById('bottom-message').value;
        const bottomTransport = document.getElementById('bottom-transport').value;

        const topName = document.getElementById('top-name').value;
        const topEmail = document.getElementById('top-email').value;
        const topPhone = document.getElementById('top-phone').value;
        const topInsuranceType = document.getElementById('top-insurance_type').value;
        const topTreatmentReason = document.getElementById('top-treatment_reason').value;
        const topCityValue = document.getElementById('top-city').value;
        const topMessage = document.getElementById('top-message').value;
        const topTransport = document.getElementById('top-transport').value;

        let isTop = false;

        if (topEmail && topCityValue) {
            isTop = true;
        }
        console.log(isTop)

        if (isTop) {
            saveData(topName, topEmail, topPhone, topInsuranceType, topTreatmentReason, topCityValue, topMessage, topTransport);
        }
        else {
            saveData(bottomName, bottomEmail, bottomPhone, bottomInsuranceType, bottomTreatmentReason, bottomCityValue, bottomMessage, bottomTransport);
        }
    }

    const saveData = async (name, email, phone, insuranceType, treatmentReason, city, message, transport) => {

        // Validate email format
        if (!email || email.length < 1) {
            alert('Veuillez entrer une adresse email valide');
            closeLoader();
            return;
        }


        // Validate required fields
        if (!insuranceType || !treatmentReason || !transport) {
            alert('Veuillez remplir tous les champs obligatoires');
            closeLoader();
            return;
        }

        console.log(city)
        if (!city || city.length == 0) {
            alert('Veuillez entrer une ville et un code postal valide');
            closeLoader();
            return;
        }

        const realCity = "";
        const realPostalCode = city;

        let firstName = name;
        let lastName = "";


        const { data, error } = await supabase.from('demandes_rdv').insert({
            patient_first_name: firstName,
            patient_last_name: lastName || "",
            email: email,
            phone_number: phone || "",
            status: 'new',
            city: realCity,
            postal_code: realPostalCode,
            notes: message || "",
            insurance_type: insuranceType,
            treatment_reason: treatmentReason,
            transport_mode: transport,
        })
        if (error) {
            console.log(error);
            alert("Une erreur est survenue lors de l'envoi de votre demande, veuillez réessayer plus tard");
            closeLoader();
        } else {
            console.log(data);
            alert("Votre demande a été envoyée avec succès");
            closeLoader();
        }
    }

    const closeLoader = () => {
        document.getElementById("loader").classList.remove("tatsu-form-lightbox-visible")
    }

    return (
        <div>
            <button className="tatsu-form-submit typo-button IE wE vE A I U"
                onClick={handleClick}>
                <div className="tatsu-form-primary-text x">Demander un
                    rendez-vous</div>
                <div className="tatsu-form-secondary-text n s x SB fB">
                </div>
            </button>
        </div>

    );
}

export default Confirm;